import { navigate } from 'gatsby';

export function switchLangUrls(lang, data, otherProps) {
  let slug = data.polylang_translations
  .filter((item) => item.polylang_current_lang === lang)
  .map((item) => {
    return item.slug;
  });

  let pathHome;
  const { componentChunkName } = otherProps.pageResources.page;
  if (componentChunkName === 'component---src-pages-home-page-home-page-js') {
    pathHome = true;
  }

  let pathPost;
  if (componentChunkName === 'component---src-pages-blog-post-js') {
    pathPost = true;
  }

  if (pathPost) {
    slug = `blog/${slug}`;
  } else if (pathHome) {
    slug = '';
  }
  navigate(`/${lang}/${slug}`);
}
